<template>
  <div class="p-grid">
    <Card class="style p-col" style="width: 100%">
      <template #title>
        <div class="p-d-flex p-jc-between">
          <h3 class="p-m-0">
            <strong>{{ pageTitle }}</strong>
          </h3>

          <ToggleButton
            v-model="isFiltersOpen"
            v-tooltip.bottom="_t('label_Display_filters')"
            class="p-button-rounded p-button-text p-button-plain"
            offIcon="pi pi-filter"
            onIcon="pi pi-filter"
            style="font-size: 16px; visibility: hidden"
          />
        </div>
      </template>

      <template #content>
        <TabView v-model:activeIndex="activeTab" @tab-click="switchTab">
          <TabPanel header="Participant">
            <DataTable
              :value="frontData"
              tableStyle="min-width: 50rem; width: 50%;"
            >
              <Column
                field="name"
                header="Name"
                style="padding-left: 14px !important"
              ></Column>
              <Column
                field="state"
                header="State"
                style="padding-left: 14px !important"
              ></Column>
              <Column
                field="action"
                header="Action"
                style="padding-left: 14px !important"
              >
                <template #body="{ data, field }">
                  <div
                    style="display: flex; flex-wrap: wrap; gap: 10px"
                    v-if="data.name === 'HTTP Connector'"
                  >
                    <Button
                      v-tooltip.bottom="'Refresh'"
                      icon="mdi mdi-repeat"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                    <Button
                      v-tooltip.bottom="'Start'"
                      icon="mdi mdi-play"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                    <Button
                      v-tooltip.bottom="'Stop'"
                      icon="mdi mdi-stop"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                    <Button
                      v-tooltip.bottom="'Restart'"
                      icon="mdi mdi-restart"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                  </div>
                  <span v-else>{{ data[field] }}</span>

                  <div
                    style="display: flex; flex-wrap: wrap; gap: 10px"
                    v-if="data.name === 'HTTPS Connector'"
                  >
                    <Button
                      v-tooltip.bottom="'Refresh'"
                      icon="mdi mdi-repeat"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                    <Button
                      v-tooltip.bottom="'Start'"
                      icon="mdi mdi-play"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                    <Button
                      v-tooltip.bottom="'Stop'"
                      icon="mdi mdi-stop"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                    <Button
                      v-tooltip.bottom="'Restart'"
                      icon="mdi mdi-restart"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                  </div>
                  <span v-else>{{ data[field] }}</span>

                  <div
                    style="display: flex; flex-wrap: wrap; gap: 10px"
                    v-if="data.name === 'SSL Certificate'"
                  >
                    <Button
                      v-tooltip.bottom="'Refresh'"
                      icon="mdi mdi-repeat"
                      class="p-button-rounded p-button-text p-button-secondary"
                      @click="getCertificates"
                    />
                    <Button
                      v-tooltip.bottom="'Generate'"
                      icon="mdi mdi-database-plus"
                      class="p-button-rounded p-button-text p-button-secondary"
                      :loading="SSLCertificateLoading"
                      @click="generateSSLCertificate"
                    />
                  </div>
                  <span v-else>{{ data[field] }}</span>
                </template>
              </Column>
            </DataTable>
          </TabPanel>
          <TabPanel header="Signal">
            <DataTable :value="signals">
              <Column
                style="padding-left: 14px !important"
                field="organization"
                header="Organisation path"
              ></Column>
              <Column
                style="padding-left: 14px !important"
                field="type"
                header="Type"
              ></Column>
              <Column
                style="padding-left: 14px !important; width: 9rem"
                field="number"
                header="Calling number"
              ></Column>
              <Column
                style="
                  padding-left: 14px !important;
                  width: 3rem;
                  text-align: center;
                "
                field="isActive"
                header="Active"
              >
                <template #body="{ data, field }">
                  <Checkbox binary v-model="data[field]" />
                </template>
              </Column>
              <Column
                style="padding-left: 14px !important; width: 14rem"
                field="duration"
                header="Group lifetime duration (days)"
              >
                <template #body="{ data, field }">
                  <InputText v-model="data[field]" />
                </template>
              </Column>
              <Column
                style="padding-left: 14px !important; width: 6rem"
                field="isRegistered"
                header="Registered"
              ></Column>
              <Column
                style="padding-left: 14px !important; width: 7rem"
                field="register"
                header="Action"
              >
                <template #body="{ data }">
                  <div v-if="data.organization === '[Total system]-[INAX]'">
                    <Button
                      v-tooltip.bottom="'Deregister'"
                      icon="mdi mdi-delete-empty"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                  </div>

                  <div v-if="data.organization === '[Total system]'">
                    <Button
                      v-tooltip.bottom="'Register'"
                      icon="mdi mdi-folder-plus-outline"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                    <Button
                      v-tooltip.bottom="'Deregister'"
                      icon="mdi mdi-delete-empty"
                      class="p-button-rounded p-button-text p-button-secondary"
                    />
                  </div>
                </template>
              </Column>
            </DataTable>
          </TabPanel>
        </TabView>
      </template>
    </Card>
  </div>
</template>

<script>
import { generateCertificates, getCertificates } from "@/api/certificates";

export default {
  data() {
    return {
      activeTab: 0,
      frontData: null,
      SSLCertificateLoading: false,
      isFiltersOpen: false,
      signals: [
        {
          organization: "[Total system]-[INAX]",
          type: "Signal App",
          number: "+375444116702",
          isActive: false,
          duration: 5,
          isRegistered: false,
          register: null,
        },
        {
          organization: "[Total system]",
          type: "Signal App",
          number: "+375447914438",
          isActive: false,
          duration: 5,
          isRegistered: false,
          register: null,
        },
      ],
    };
  },
  mounted() {
    this.frontData = [
      {
        id: "0",
        name: "HTTP Connector",
        state: "STARTED",
        action: "",
      },
      {
        id: "1",
        name: "HTTPS Connector",
        state: "STARTED",
        action: "",
      },
      {
        id: "2",
        name: "SSL Certificate",
        state: "1",
        action: "",
      },
    ];

    this.getCertificates();

    const tab = this.$route.query.tab ?? "0";
    if (tab) {
      this.activeTab = parseInt(tab);
      this.$router.push("/modules?tab=" + tab);
    }
  },
  watch: {
    "$route.query.tab"() {
      const tab = this.$route.query.tab ?? "0";
      this.activeTab = parseInt(tab);
    },
  },
  methods: {
    switchTab(value) {
      this.$router.push(`/modules?tab=${value.index}`);
    },
    getCertificates() {
      getCertificates().then(
        (response) => (this.frontData[2].state = response.data)
      );
    },
    generateSSLCertificate() {
      this.SSLCertificateLoading = true;
      generateCertificates().finally(
        () => (this.SSLCertificateLoading = false)
      );
    },
  },
  computed: {
    pageTitle() {
      switch (this.activeTab) {
        case 0:
          return "Participant module";
        case 1:
          return "Signal module";
        default:
          return "Participant module";
      }
    },
  },
};
</script>

<style>
.p-button-icon {
  font-size: 15px !important;
}
</style>
